import { Pipe, PipeTransform } from '@angular/core';
import { formatCentralDate } from '@bodyanalytics/data-models-ui';

/**
 * Render a stored instant as its calendar date in the business display
 * timezone (Central) — the template seam over
 * {@link formatCentralDate} (`@bodyanalytics/data-models-ui`).
 *
 * Use this instead of Angular's bare `| date:` for anything derived from
 * `TestingEvent.testEventDate` (or any other CT-anchored stored instant):
 * the bare DatePipe renders in the viewer's browser timezone, so an evening
 * event (`'2026-08-15T00:30:00.000Z'` = Aug 14 7:30 PM CDT) shows as
 * "August 15" for a UTC/east-of-CT viewer, and UTC-midnight-adjacent
 * instants shift a day EARLY for viewers west of CT. Times on the same
 * surfaces are already CT-pinned via formatCentralTime — dates must match.
 *
 * Patterns are date-fns tokens (NOT Angular DatePipe names): the default is
 * the `'fullDate'` equivalent `'EEEE, MMMM d, y'`; use e.g. `'MMM d, y'`
 * (mediumDate), `'M/d/yy'` (shortDate), `'EEE'`, `'d'`, `'MMM'`. Never pass
 * `'YYYY'`/`'DD'` — date-fns throws on week-numbering tokens.
 *
 * Nullish/empty input renders as an empty string (matching DatePipe's
 * null-in/nothing-out template behavior); malformed non-empty input degrades
 * to the shared `'—'` placeholder rather than throwing mid-render.
 */
@Pipe({
  name: 'centralDate',
})
export class CentralDatePipe implements PipeTransform {
  transform(value: string | number | Date | null | undefined, pattern = 'EEEE, MMMM d, y'): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    return formatCentralDate(value, pattern);
  }
}
